import { Location } from '@angular/common';
import { Component, Input } from '@angular/core';

/**
 * Modern page header component
 * Used across the application to provide a consistent header style
 */
@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {
  /** Main title of the page (will be translated) */
  @Input() title: string;

  /** Optional subtitle of the page (will be translated) */
  @Input() subtitle: string;

  /** Whether to show the action button */
  @Input() showActionBtn: boolean = true;

  /** Text for the action button */
  @Input() btnText: string;

  /** Link for the action button */
  @Input() btnLink: string;

  /** Whether to show the back button */
  @Input() showGoBackBtn: boolean = true;

  /** Whether the action button is disabled */
  @Input() disabled: boolean = false;

  /** Tooltip text for the action button */
  @Input() tooltipText: string = '';

  constructor(private location: Location) {}

  /** Navigate back to the previous location */
  public navigateBack() {
    this.location.back();
  }
}
